"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  id: 1,
  name: "Elena P.",
  role: "Soil Scientist",
  quote: "The precision in their soil analysis is revolutionary. We've seen a 20% increase in nutrient efficiency since implementation.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/testimonial_avatar_eleanor.png"
}, {
  id: 2,
  name: "Marcus Chen",
  role: "Farm Manager",
  quote: "A truly premium service. The data visualization makes complex agricultural metrics accessible and actionable for our whole team.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/testimonial_avatar_marcus.png"
}, {
  id: 3,
  name: "Sarah Jenkins",
  role: "Agronomist",
  quote: "Unmatched expertise. They don't just provide raw data; they provide a scientific roadmap for long-term land sustainability.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/testimonial_avatar_sarah.png"
}, {
  id: 4,
  name: "Julian V.",
  role: "Environmental Consultant",
  quote: "The attention to microbial health detail is profound. It's rare to find a partner so dedicated to the deep science of growth.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/testimonial_avatar_julian.png"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}